var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("basic-container", [
    _c(
      "div",
      { staticClass: "cancel-user-container" },
      [
        _c(
          "div",
          { staticClass: "search-area" },
          [
            _c(
              "el-form",
              {
                staticClass: "demo-form-inline",
                attrs: { inline: true, model: _vm.searchForm, size: "small" },
              },
              [
                _c(
                  "el-form-item",
                  [
                    _c("el-input", {
                      attrs: { placeholder: "用户账户", clearable: "" },
                      model: {
                        value: _vm.searchForm.mobile,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "mobile", $$v)
                        },
                        expression: "searchForm.mobile",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "全部状态", clearable: "" },
                        model: {
                          value: _vm.searchForm.cancelStatus,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "cancelStatus", $$v)
                          },
                          expression: "searchForm.cancelStatus",
                        },
                      },
                      [
                        _c("el-option", {
                          attrs: { label: "注销冻结", value: "1" },
                        }),
                        _c("el-option", {
                          attrs: { label: "注销", value: "2" },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "全部注册方式", clearable: "" },
                        model: {
                          value: _vm.searchForm.regType,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "regType", $$v)
                          },
                          expression: "searchForm.regType",
                        },
                      },
                      _vm._l(_vm.regTypeList, function (item) {
                        return _c("el-option", {
                          key: item.dictKey,
                          attrs: { label: item.dictValue, value: item.dictKey },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  [
                    _c("DynamicOption", {
                      attrs: {
                        placeholder: "全部来源渠道",
                        singleSelect: true,
                        params: _vm.searchOptions,
                      },
                      model: {
                        value: _vm.searchForm.appid,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "appid", $$v)
                        },
                        expression: "searchForm.appid",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "最后登陆产品", clearable: "" },
                        model: {
                          value: _vm.searchForm.pid,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "pid", $$v)
                          },
                          expression: "searchForm.pid",
                        },
                      },
                      _vm._l(_vm.clientTypes, function (item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  [
                    _c("el-date-picker", {
                      attrs: {
                        type: "daterange",
                        "range-separator": "至",
                        "start-placeholder": "请选择注册时间",
                        "end-placeholder": "结束时间",
                        "value-format": "yyyy-MM-dd HH:mm:ss",
                        "default-time": ["00:00:00", "23:59:59"],
                      },
                      model: {
                        value: _vm.time,
                        callback: function ($$v) {
                          _vm.time = $$v
                        },
                        expression: "time",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.handleSearch },
                      },
                      [_vm._v("搜索")]
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "success" },
                        on: { click: _vm.handleExport },
                      },
                      [_vm._v("导出为Excel")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-table",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.listLoading,
                expression: "listLoading",
              },
            ],
            attrs: {
              "cell-style": { "text-align": "center" },
              "header-cell-style": { "text-align": "center" },
              "max-height": _vm.tableHeight,
              "element-loading-text": "加载中",
              border: "",
              data: _vm.tableData,
              "row-style": { height: "30px" },
            },
          },
          [
            _c("el-table-column", {
              attrs: { prop: "id", label: "ID", width: "80" },
            }),
            _c("el-table-column", {
              attrs: { prop: "mobile", label: "用户账号", width: "120" },
            }),
            _c("el-table-column", {
              attrs: { prop: "status", label: "状态", width: "100" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "el-tag",
                        {
                          attrs: {
                            type:
                              scope.row.cancelState === 1
                                ? "warning"
                                : "danger",
                          },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                scope.row.cancelState === 1
                                  ? "注销冻结"
                                  : "已注销"
                              ) +
                              "\n          "
                          ),
                        ]
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: { label: "注册方式", width: "120" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.getRegTypeDescByRegType(scope.row.regType)
                          ) +
                          "\n        "
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: { prop: "createTime", label: "注册时间", width: "180" },
            }),
            _c("el-table-column", {
              attrs: {
                prop: "source",
                label: "来源渠道",
                width: "300",
                "show-overflow-tooltip": "",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.getSourceChannel(scope.row)) +
                          "\n        "
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                prop: "productName",
                label: "最后登陆产品",
                width: "150",
              },
            }),
            _c("el-table-column", {
              attrs: {
                prop: "deviceInfo",
                label: "最后设备号ID",
                width: "150",
                "show-overflow-tooltip": "",
              },
            }),
            _c("el-table-column", {
              attrs: {
                prop: "lastTime",
                label: "最后账号登录时间",
                width: "180",
              },
            }),
            _c("el-table-column", {
              attrs: { label: "操作", width: "220", fixed: "right" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      scope.row.cancelState === 1
                        ? _c(
                            "el-button",
                            {
                              attrs: { size: "mini", type: "warning" },
                              on: {
                                click: function ($event) {
                                  return _vm.handleUnbind(scope.row)
                                },
                              },
                            },
                            [_vm._v("解除注销")]
                          )
                        : _vm._e(),
                      scope.row.cancelState === 1
                        ? _c(
                            "el-button",
                            {
                              attrs: { size: "mini", type: "danger" },
                              on: {
                                click: function ($event) {
                                  return _vm.handleConfirm(scope.row)
                                },
                              },
                            },
                            [_vm._v("注销确认")]
                          )
                        : _vm._e(),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "table_pagination" },
          [
            _c("el-pagination", {
              staticClass: "app-pagination",
              attrs: {
                background: "",
                "current-page": _vm.page.current,
                "page-sizes": _vm.page.pageSizeArr,
                "page-size": _vm.page.size,
                layout: _vm.paginationLayout,
                total: _vm.page.total,
              },
              on: {
                "size-change": _vm.handleSizeChange,
                "current-change": _vm.handleCurrentChange,
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }